/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ReviewData/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import AppointmentSlotRepeater from './AppointmentSlotRepeater/index'
import DentalPlanRepeater from './DentalPlanRepeater/index'
import LocationRepeater from './LocationRepeater/index'
import PatientBirthdayRepeater from './PatientBirthdayRepeater/index'
import PatientEmailRepeater from './PatientEmailRepeater/index'
import PatientFirstNameRepeater from './PatientFirstNameRepeater/index'
import PatientLastNameRepeater from './PatientLastNameRepeater/index'
import PatientPhoneRepeater from './PatientPhoneRepeater/index'
import React from 'react'
import ResponsiblePersonEmailRepeater from './ResponsiblePersonEmailRepeater/index'
import ResponsiblePersonFirstNameRepeater from './ResponsiblePersonFirstNameRepeater/index'
import ResponsiblePersonLastNameRepeater from './ResponsiblePersonLastNameRepeater/index'
import ResponsiblePersonPhoneRepeater from './ResponsiblePersonPhoneRepeater/index'
import ResponsiblePersonRelationshipRepeater from './ResponsiblePersonRelationshipRepeater/index'
import ResponsiblePersonRepeater from './ResponsiblePersonRepeater/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import viewPath from './viewPath.js'
import { animated, useSpring } from "@react-spring/web"



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function ReviewData({
  children,
  viewPath = "/App/Form/Data/ReviewData",
  dentalPlanRepeater,
  locationRepeater,
  appointmentSlotRepeater,
  patientFirstNameRepeater,
  patientLastNameRepeater,
  patientEmailRepeater,
  patientPhoneRepeater,
  patientBirthdayRepeater,
  responsiblePersonRepeater,
  responsiblePersonFirstNameRepeater,
  responsiblePersonLastNameRepeater,
  responsiblePersonEmailRepeater,
  responsiblePersonPhoneRepeater,
  responsiblePersonRelationshipRepeater
  
}) {
  let isBefore = useIsBefore()
let animatedVertical1 = useSpring({
"config": {
tension: 180,
friction: 12,
},
"delay": 50,
"from": {"translateY": "0px"},
"to": {"translateY": isBefore ? "-10px" : "0px"},
})
  return (<React.Fragment
>
<animated.div
  data-testid="ReviewData.Vertical"
  data-view-path={viewPath}
 style={{"--ty-2-6YFAH": animatedVertical1.translateY,'--o-1-6YFAH': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={dentalPlanRepeater}>
<DentalPlanRepeater
  viewPath={`${viewPath}/DentalPlanRepeater`}
/>
</fromFlow.When>
<fromFlow.When is={locationRepeater}>
<LocationRepeater
  viewPath={`${viewPath}/LocationRepeater`}
/>
</fromFlow.When>
<fromFlow.When is={appointmentSlotRepeater}>
<AppointmentSlotRepeater
  viewPath={`${viewPath}/AppointmentSlotRepeater`}
/>
</fromFlow.When>
<fromFlow.When is={patientFirstNameRepeater}>
<PatientFirstNameRepeater
  viewPath={`${viewPath}/PatientFirstNameRepeater`}
/>
</fromFlow.When>
<fromFlow.When is={patientLastNameRepeater}>
<PatientLastNameRepeater
  viewPath={`${viewPath}/PatientLastNameRepeater`}
/>
</fromFlow.When>
<fromFlow.When is={patientEmailRepeater}>
<PatientEmailRepeater
  viewPath={`${viewPath}/PatientEmailRepeater`}
/>
</fromFlow.When>
<fromFlow.When is={patientPhoneRepeater}>
<PatientPhoneRepeater
  viewPath={`${viewPath}/PatientPhoneRepeater`}
/>
</fromFlow.When>
<fromFlow.When is={patientBirthdayRepeater}>
<PatientBirthdayRepeater
  viewPath={`${viewPath}/PatientBirthdayRepeater`}
/>
</fromFlow.When>
<fromFlow.When is={responsiblePersonRepeater}>
<ResponsiblePersonRepeater
  viewPath={`${viewPath}/ResponsiblePersonRepeater`}
/>
</fromFlow.When>
<fromFlow.When is={responsiblePersonFirstNameRepeater}>
<ResponsiblePersonFirstNameRepeater
  viewPath={`${viewPath}/ResponsiblePersonFirstNameRepeater`}
/>
</fromFlow.When>
<fromFlow.When is={responsiblePersonLastNameRepeater}>
<ResponsiblePersonLastNameRepeater
  viewPath={`${viewPath}/ResponsiblePersonLastNameRepeater`}
/>
</fromFlow.When>
<fromFlow.When is={responsiblePersonEmailRepeater}>
<ResponsiblePersonEmailRepeater
  viewPath={`${viewPath}/ResponsiblePersonEmailRepeater`}
/>
</fromFlow.When>
<fromFlow.When is={responsiblePersonPhoneRepeater}>
<ResponsiblePersonPhoneRepeater
  viewPath={`${viewPath}/ResponsiblePersonPhoneRepeater`}
/>
</fromFlow.When>
<fromFlow.When is={responsiblePersonRelationshipRepeater}>
<ResponsiblePersonRelationshipRepeater
  viewPath={`${viewPath}/ResponsiblePersonRelationshipRepeater`}
/>
</fromFlow.When>
</animated.div>
{children}
</React.Fragment>)
}